import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Week from "../Components/Week";
import Banner from "../Components/Banner";

const Thired_Blog = () => {
  const styles = {
    h4: {
      color: "#006a4f",
      fontFamily: `'Poppins', sans-serif`,
    },
    h6: {
      color: "#006a4f",
      fontFamily: `sans-serif`,
      fontSize: "1.2rem",
      fontWeight: 500,
    },
    span: {
      color: "#c63b36",
      fontSize: "1.1rem",
      fontWeight: 700,
    },
    p: {
      fontFamily: `serif`,
      //   color: '#878787',
      fontSize: "1.25rem",
      color: "#001f3f",
      wordSpacing: "0.3rem",
    },
    //    main_heading:{
    //     fontSize:"2rem",
    //     textAlign:"center"
    //    }
  };
  //    className="col-md-6 order-md-2"

  const ImageComponent = () => {
    const styles = {
      container: {
        width: "100%",
        overflow: "hidden",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      },
      image: {
        width: "100%",
        display: "block",
      },
    };

    return (
      <div style={styles.container} className="mb-5">
        <img
          src="https://cdn.pixabay.com/photo/2024/04/08/20/00/brain-8684349_640.jpg"
          alt="Example"
          style={styles.image}
        />
      </div>
    );
  };

  return (
    <>
      <style>
        @import
        url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
        {`
          @media (max-width: 600px) {
            h4 {
              font-size: 1.3rem;
              text-align: center;
            }
            h6 {
             font-size: 1rem;
            }
            span {
              font-size: 1rem;
            }
            p{
              font-size: 1rem;
              padding: 0 1rem;
              text-align: justify;
            }
            a{
            text-decoration:none;
            }
          }
        `}
      </style>
      <div className="container">
        <Banner
          heading={"From Beginner to Pro: How to Start Your Career in Robotics"}
          image={
            "https://cdn.pixabay.com/photo/2024/04/26/17/15/humanoid-8722271_640.png"
          }
        />
        <section className="container mt-5">
          {/* First Section: Text Left, Image Right */}
          <div className="row align-items-center mb-5">
            <div className="col">
              <h4 style={styles.h4}>Introduction</h4>
              <p className="" style={styles.p}>
                Robotics is transforming industries, from manufacturing to
                healthcare, and even space exploration. If you've ever dreamed
                of building intelligent machines, this guide will help you
                navigate the path from a beginner to a professional in the field
                of robotics.
              </p>
            </div>
          </div>

          {/* Second Section: Image Left, Text Right */}
          <div className="row align-items-center mb-2">
            <div className="col">
              <h4 style={styles.h4}>Step 1: Understand the Basics</h4>
              <p className="mb-0" style={styles.p}>
                Before diving into complex robotics systems, it's crucial to
                understand the fundamentals. Start with:
              </p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.h6}>● Programming:</span>
                  <span style={styles.p}>
                    {" "}
                    Learn languages like Python, C, and C++.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Mathematics:</span>
                  <span style={styles.p}> Brush up on linear algebra, calculus, and probability.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Physics & Electronics:</span>
                  <span style={styles.p}>
                    {" "}
                    Understand how motors, sensors, and circuits work.
                  </span>
                </div>

                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Mechanical Design:</span>
                  <span style={styles.p}> Get familiar with CAD software and 3D printing.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <ImageComponent />

          <div className="row align-items-center">
            <div className="col">
              <h4 style={styles.h4}>Step 2: Learn About Robotics Components</h4>
              <p className="mb-1" style={styles.p}>
                A robot consists of several components, and understanding these
                will help you build your own:
              </p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.h6}>● Microcontrollers:</span>
                  <span style={styles.p}> Arduino, Raspberry Pi, ESP32</span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Actuators & Motors:</span>
                  <span style={styles.p}> Servo motors, stepper motors, and DC motors
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Sensors:</span>
                  <span style={styles.p}>
                    {" "}
                    Proximity sensors, gyroscopes, accelerometers, LIDAR
                  </span>
                </div>

                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Power Systems:</span>
                  <span style={styles.p}> Batteries, power regulators, solar panels
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col">
              <h4 style={styles.h4}>Step 3: Hands-on Practice</h4>
              <p className="mb-0" style={styles.p}>
                Theory alone isn’t enough. Start experimenting with small
                projects:
              </p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.p}>
                    ● Learn languages like Python, C, and C++.
                  </span>
                </div>
                <div className="col-12 mb-1">
                  <span style={styles.p}>
                    ● Build a line-following robot using Arduino
                  </span>
                </div>
                <div className="col-12 mb-1">
                  <span style={styles.p}>
                    ● Create a simple robotic arm with servo motors.
                  </span>
                </div>

                <div className="col-12 mb-1">
                  <span style={styles.p}>
                    ● Work with Raspberry Pi to control robots via Python. .
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col">
              <h4 style={styles.h4}>
                Step 4: Learn Robotics Frameworks & AI Integration
              </h4>
              <p className="mb-1" style={styles.p}>
                Modern robots are increasingly powered by AI and machine
                learning. You should explore:
              </p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.h6}>● ROS (Robot Operating System):</span>
                  <span style={styles.p}>
                    {" "}
                    The standard framework for developing robots..
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Computer Vision:</span>
                  <span style={styles.p}> OpenCV for object detection and recognition.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● AI & Machine Learning: </span>
                  <span style={styles.p}>
                    {" "}
                    TensorFlow and PyTorch for robotics automation.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center mb-2">
            <div className="col">
              <h4 style={styles.h4}>Step 5: Specialize in an Industry</h4>
              <p className="mb-0" style={styles.p}>
                Robotics is a broad field. Some specializations include:
              </p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.h6}>● Industrial Automation:</span>
                  <span style={styles.p}>
                    {" "}
                    Working with robotic arms for manufacturing.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Medical Robotics:</span>
                  <span style={styles.p}> Developing robotic prosthetics or surgical assistants.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Autonomous Vehicles:</span>
                  <span style={styles.p}> Designing self-driving cars and drones.
                  </span>
                </div>

                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Humanoid Robots:</span>
                  <span style={styles.p}> Building AI-powered humanoid assistants.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col">
              <h4 style={styles.h4} className="pb-2">Step 6: Join the Robotics Community</h4>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.h6}>● Participate in Competitions:</span>
                  <span style={styles.p}> Events like RoboCup, DARPA Robotics Challenge.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Contribute to Open Source:</span>
                  <span style={styles.p}> Work on ROS-based projects.</span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Network with Professionals:</span>
                  <span style={styles.p}>
                    {" "}
                    Join LinkedIn groups, attend robotics meetups.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center mb-2">
            <div className="col">
              <h4 style={styles.h4}>Step 7: Get Certified & Apply for Jobs</h4>
              <p className="mb-0" style={styles.p}>
                Many companies value hands-on experience, but certifications can
                help:
              </p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.h6}>● Professional Certifications:</span>
                  <span style={styles.p}>
                    {" "}
                    Robotics certifications from MIT, Coursera.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Internships & Projects:</span>
                  <span style={styles.p}> Gain practical experience through internships and research
                    projects.
                  </span>
                </div>
                <div className="col-12  mb-1">
                  <span style={styles.h6}>● Job Opportunities:</span>
                  <span style={styles.p}>
                    {" "}
                    Look for roles in companies like Boston Dynamics or local
                    startups.
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center mb-2">
            <div className="col">
              <h4 style={styles.h4}>
                Why Choose CoderMonk for Robotics Training?
              </h4>
              <p className="" style={styles.p}>
                At{" "}
                <span style={styles.span}>CoderMonk (Jalandhar, Punjab)</span>,
                we provide hands-on robotics training with real-world projects.
                Our 45-day and 6-month programs cover:
              </p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <div className="d-flex flex-column ms-3">
                <div className="col-12 mb-1">
                  <span style={styles.p}>
                    ● Microcontrollers (Arduino, ESP32, Raspberry Pi)
                  </span>
                </div>
                <div className="col-12 mb-1">
                  <span style={styles.p}>
                    ● Actuators, sensors, and embedded firmware
                  </span>
                </div>
                <div className="col-12 mb-1">
                  <span style={styles.p}>
                    ● AI-powered robotics with OpenCV and ROS
                  </span>
                </div>
                <p style={styles.p} className="mt-2">
                  Interested? Contact us at  <a
                  href="tel:6284636956"
                  style={{ ...styles.span, textDecoration: "none" }}
                   
                >+916284636956</a> to kickstart your
                  robotics career today!
                </p>
              </div>
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col">
              <h4 style={styles.h4}>Conclusion</h4>
              <p className="" style={styles.p}>
                Starting a career in robotics requires a mix of coding,
                electronics, and AI skills. With consistent learning and
                hands-on projects, you can transition from a beginner to a
                professional and build the future of automation
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Thired_Blog;
